import { useQuery } from "@common/utils/use-query";
import { Notification } from "./types";

// Shared by the Alerts page and the SideNav badge. React Query dedupes on the
// query key, so the two callers issue a single request.
export const useGetNotifications = () => {
  return useQuery<Notification[] | null>("/account/notifications");
};

// Local preview fixture — swap the return above for this to work on the list
// without a running API:
//
// export const useGetNotifications = () => ({
//   isLoading: false,
//   error: null,
//   data: [
//     {
//       id: "abcd12345",
//       date: "2026-08-10",
//       type: "warning",
//       title: "Security documents",
//       message:
//         "We have additional information about the security incident on your instance.\n- [Download forensic logs(zip)](%s)\n- [Download investigation timeline(PDF)](%s)\n- [Download security report (PDF)](%s)",
//     },
//     {
//       id: "abcd1234",
//       date: "2026-08-10",
//       type: "warning",
//       title: "Security alert information",
//       message:
//         "We have additional information about the security incident on your instance, you can download that information **[here](%s)**.",
//     },
//     {
//       id: "ijkl9012",
//       date: "2026-08-04",
//       type: "warning",
//       title: "Security alert",
//       message:
//         "We have detected a security issue on your instance. The issue has been fixed. You can download forensic logs [here](%s).",
//     },
//   ] as Notification[],
// });
